import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import Loading from 'apa/components/Loading';
import {Button, Input, Label} from 'reactstrap';
import autobind from 'autobind-decorator';
import {createTemplate, loadTemplateList, selectTemplate} from 'template/actions';
import Dialog from 'apa/containers/Dialog';

@connect(state => ({
    template: state.template
}), dispatch => {
    return {
        createManual: (manual) => dispatch(createTemplate(manual)),
        loadManualList: (category) => dispatch(loadTemplateList(category)),
        selectManual: (manual) => dispatch(selectTemplate(manual)),
    };
})
export default class NewTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            name: '',
            data: '',
            uploading: false
        };
    }

    @autobind
    toggle() {
        this.setState({isOpen: !this.state.isOpen});
    }

    @autobind
    confirm() {
        const data = this.state.data
        data.append('name', this.state.name);
        data.append('category', this.props.template.selectedTemplateCategory.id);
        this.props.createManual(data)
        this.toggle()
    }

    @autobind
    changeFile(e) {
        const data = new FormData();
        data.append('template_file', e.target.files[0]);
        this.setState({data, name: this.state.name || e.target.files[0].name});
    }

    render() {
        if (!this.props.template.selectedTemplateCategory)
            return null;
        return (<Fragment>
            <Button color='primary' onClick={this.toggle}>Neue Mustervorlage anlegen</Button>
            <Dialog isOpen={this.state.isOpen} toggle={this.toggle} confirm={this.confirm}
                    title="Neue Mustervolage erstellen">
                <Fragment>
                    {!this.state.uploading &&
                    <Fragment>
                        <Label>
                            Name
                        </Label>
                        <Input type="text" value={this.state.name}
                               onChange={e => this.setState({name: e.target.value})}/>
                        <Label>
                            Vorlage
                        </Label>
                        <Input type="file" onChange={this.changeFile}/>
                    </Fragment>}
                    {this.state.uploading && <Loading/>}
                </Fragment>
            </Dialog>
        </Fragment>);
    }
}
